<template>
  <div style="margin-top:20px">
    <el-form ref="form" label-width="100px" :model="form">
      <el-form-item label="公告标题" style="margin-right:15px">
        <el-input v-model="form.alert" :disabled="mode === 'detail'" />
      </el-form-item>
      <el-form-item label="公告内容" style="margin-right:15px">
        <!-- <el-input
          v-model="form.content"
          autosize
          type="textarea"
          placeholder="请输入公告内容"
          clearable
          :disabled="mode === 'detail'"
        /> -->
        <myEditor v-model="form.content" :disabled="false" />
      </el-form-item>
      <!-- 发布时间 -->
      <!-- <el-form-item label="发布时间" style="margin-right:15px">
        <el-date-picker
          v-model="form.pushTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择发布时间"
          :disabled="mode === 'detail'"
          :picker-options="pickerOptions"
          @change="handleDateChange"
        />
      </el-form-item> -->
    </el-form>
    <div style="text-align: right; margin-top: 20px;">
      <el-button v-if="mode !== 'detail'" @click="handleCancel">
        取消
      </el-button>
      <el-button v-if="mode !== 'detail'" type="primary" @click="handleSave">
        保存
      </el-button>
    </div>
  </div>
</template>
<script>
import myEditor from "@/components/MyEditor";
import { parseTime } from "@/utils";
import {
  getAnnouncementDetail,
  addAnnouncement,
  updateAnnouncement
} from "@/api/user";

const ALLOWED_IMG_HOST = "mlwccy.oss-cn-qingdao.aliyuncs.com";

export default {
  name: "AnnouncementDetail",
  components: {
    myEditor
  },
  props: {
    mode: {
      type: String,
      default: "detail",
      validator: value => {
        return ["detail", "edit", "add"].includes(value);
      }
    },
    code: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      emptyForm: {},
      form: {
        code: "",
        alert: "",
        content: "",
        pushTime: ""
      },
      pickerOptions: {
        disabledDate: time => {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() < today.getTime();
        }
      }
    };
  },
  watch: {
    mode: {
      handler: function() {
        this.initForm();
      },
      immediate: true
    },
    code: {
      handler: function() {
        if (this.mode === "edit") {
          this.getInfo(this.code);
        }
      },
      immediate: true
    }
  },
  created() {
    this.emptyForm = JSON.parse(JSON.stringify(this.form));
  },
  methods: {
    normalizeImgSrcInContent(content) {
      if (!content || typeof content !== "string") {
        return content;
      }
      return content.replace(
        /(<img\b[^>]*\bsrc=["'])([^"']+)/gi,
        (match, prefix, url) => prefix + url.replace(/^http:\/\//i, "https://")
      );
    },
    getImgSrcHost(src) {
      if (!src) {
        return null;
      }
      const trimmed = src.trim();
      if (/^(data|blob):/i.test(trimmed)) {
        return null;
      }
      try {
        if (trimmed.startsWith("//")) {
          return new URL(`https:${trimmed}`).hostname;
        }
        if (/^https?:\/\//i.test(trimmed)) {
          return new URL(trimmed).hostname;
        }
        return null;
      } catch (e) {
        return null;
      }
    },
    validateImgSrcInContent(content) {
      if (!content || typeof content !== "string") {
        return true;
      }
      const imgSrcRegex = /<img\b[^>]*\bsrc=["']([^"']+)/gi;
      let match;
      while ((match = imgSrcRegex.exec(content)) !== null) {
        if (this.getImgSrcHost(match[1]) !== ALLOWED_IMG_HOST) {
          return false;
        }
      }
      return true;
    },
    handleDateChange(val) {
      console.log(val);
      this.form.pushTime = val;
    },
    initForm() {
      if (this.mode === "detail" || this.mode === "edit") {
        this.getInfo(this.code);
      }
    },
    getInfo(code) {
      this.form = {
        code: "",
        alert: "",
        content: "",
        pushTime: ""
      };
      getAnnouncementDetail(code).then(response => {
        this.form = {
          code: response.data.code,
          alert: response.data.alert,
          content: response.data.content,
          pushTime: response.data.pushTime
        };
        console.log("赋值==========", this.form);
      });
    },
    handleSave() {
      if (!this.form.alert) {
        this.$message.error("请输入公告标题");
        return;
      }
      if (!this.form.content) {
        this.$message.error("请输入公告内容");
        return;
      }
      console.log("参数==========", this.form);
      const content = this.normalizeImgSrcInContent(this.form.content);
      if (!this.validateImgSrcInContent(content)) {
        this.$message.error("不允许直接粘贴图片，请通过图片上传");
        return;
      }

      if (this.mode === "add") {
        addAnnouncement({
          code: this.form.code,
          alert: this.form.alert,
          content,
          pushTime: parseTime(new Date())
        }).then(response => {
          this.$message({
            message: response.msg || "新增成功",
            type: "success"
          });
          this.$emit("success", "add");
          this.handleCancel();
        });
      } else if (this.mode === "edit") {
        let data = {
          code: this.form.code,
          alert: this.form.alert,
          content,
          pushTime: parseTime(new Date())
        };
        console.log("时间????????======", data);
        updateAnnouncement(data).then(response => {
          this.$message({
            message: response.msg || "修改成功",
            type: "success"
          });
          this.$emit("success", "edit");
          this.handleCancel();
        });
      }
    },
    handleCancel() {
      this.$emit("cancel");
    }
  }
};
</script>
<style lang="scss" scoped></style>
